/**
 * HomepageIntegratedSolutions Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders HomepageIntegratedSolutions Block
 */

import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBTypography } from '@svb/svb-react-components';
import Loading from '@svb/api-loading-component/dist/components/index';
// import { Utils } from '@svb/api-content-component';
import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { SVBCard } from '@svb/svb-react-components';
import { slugCreator } from '../../core/useStore';

/**
 * HomepageIntegratedSolutions
 * @param content: url of the HomepageIntegratedSolutions content
 * @param backgroundImg: url for the backgrond image for this section
 * @returns HomepageIntegratedSolutions block
 */

const HomepageIntegratedSolutions = ({ datatestid, testMockContent, content, backgroundImg }) => {
  const [loading, setLoading] = useState(true);
  // const token = localStorage.getItem('token');
  const { regenTokenandBrowse } = browseAPIhandler();
  const getIntegrationContent = datatestid
    ? testMockContent
    : getFileContent(`${content}`, regenTokenandBrowse);

  useEffect(() => {
    if (getIntegrationContent.type === 'success') {
      setLoading(false);
    }
  }, [getIntegrationContent.response]);

  if (loading) {
    return <Loading />;
  }

  // Overrides HomepageIntegratedSolutionsSection tag from markdown and renders IntegratedSolutionsSection wrapper element
  const HomepageIntegratedSolutionsSection = ({ children }) => {
    return (
      <>
        <div className='homepage_hero__Subseparation'></div>
        <div className='cards row justify-content-between'>{children}</div>
      </>
    );
  };

  // Overrides Card tag from markdown and renders IntegrationCard
  const HomepageIntegrationCard = ({ link, cardIcon, title, description, buttonLabel }) => {
    const learnMoreTestid = slugCreator(buttonLabel + '-' + link);
    const cardTestid = slugCreator('card-' + title);
    const cardOptions = {
      externalLink: true,
    };
    const LearnMoreCardLabel = () => (
      <span className='learn-more-label'>
        {buttonLabel || 'Learn More'}
        <i className='fa-solid fa-arrow-right right-arrow-icon' />
      </span>
    );
    return (
      <div className='col-md-4 col-sm-12 align-item-stretch d-flex mb-4'>
        <SVBCard
          buttonLabel={LearnMoreCardLabel()}
          link={link}
          cardOptions={cardOptions}
          cardIcon={cardIcon}
          description={description}
          title={title}
          explicitImgWidth={50}
          explicitImgHeight={50}
          lazyLoading={true}
          datatestid={{ card: cardTestid, learnMore: learnMoreTestid }}
        />
      </div>
    );
  };
  const bg_img = backgroundImg
    ? {
        backgroundImage: `linear-gradient(90.26deg, rgba(0, 0, 0, 0.56) 37.16%, rgba(0, 0, 0, 0) 67.26%), url(${backgroundImg})`,
      }
    : {};
  if (getIntegrationContent.response) {
    return (
      <section id='homepage-integrated' className='integrated-solution-section' style={bg_img}>
        <div className='container svb-container-fixed col-md-9 col-sm-12'>
          <div className='row'>
            <Markdown
              options={{
                overrides: {
                  h2: {
                    component: SVBTypography,
                    props: {
                      type: 'heading-large',
                      variant: 'header-2',
                    },
                  },
                  HomepageIntegratedSolutionsSection: {
                    component: HomepageIntegratedSolutionsSection,
                  },
                  Card: {
                    component: HomepageIntegrationCard,
                  },
                },
              }}
            >
              {getIntegrationContent.response}
            </Markdown>
          </div>
        </div>
      </section>
    );
  }
};
export default HomepageIntegratedSolutions;
